import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import { useCategoryItems, useSpreadTypes } from "../../constants/readingTypes";
import ReadingType from "@/components/reading/ReadingTypeCard";
import useCards from "@/hooks/useCards";
import { track } from "@/third-party/MixPanel";

const SelectReading: React.FC = () => {
  const navigate = useNavigate();
  const { setSelectedReading } = useCards();
  const categoryItems = useCategoryItems();
  const spreadTypes = useSpreadTypes();

  // Get valid category IDs for validation
  const validCategories = categoryItems.map(item => item.id);

  // Initialize category from localStorage or default to "general"
  const getInitialCategory = () => {
    const savedCategory = localStorage.getItem('selectedReadingCategory');
    return savedCategory && validCategories.includes(savedCategory) ? savedCategory : "general";
  };

  const [category, setCategory] = useState(getInitialCategory);

  // Load saved category on mount
  useEffect(() => {
    const savedCategory = localStorage.getItem('selectedReadingCategory');
    if (savedCategory && validCategories.includes(savedCategory)) {
      setCategory(savedCategory);
    }
  }, [validCategories]);

  const categoryClicked = (newCategory: string) => {
    setCategory(newCategory);
    // Save selected category to localStorage
    localStorage.setItem('selectedReadingCategory', newCategory);
  };

  const onReadingClick = (key: number) => {
    const item = spreadTypes[category as keyof typeof spreadTypes][key];
    setSelectedReading(item);
    track('spread_category_selected', { item });
    navigate(`/display-reading/${item.id}`)
  }

  return (
    <div className="flex flex-col w-[calc(100%+32px)] min-h-screen -ml-[16px] -mt-[10px]">
      <Box sx={{
        position: 'fixed',
        top: '48px',
        left: 0,
        right: 0,
        width: '100%',
        paddingTop: 2,
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: '#F5F3F0',
        zIndex: 40
      }}>
        <Tabs
          value={category}
          onChange={(event, newValue) => categoryClicked(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            '& .MuiTabs-scrollButtons': {
              '&.Mui-disabled': { opacity: 0.3 }
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              minWidth: 'auto',
              padding: '0px 0px',
              color: '#1B2937',
              '&.Mui-selected': {
                color: '#1B2937',
                fontWeight: 600
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#F5F3F0'
            }
          }}
        >
          {categoryItems.map((item) => (
            <Tab
              key={item.id}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, fontWeight: 400, padding: 2 }}>
                  {/*   <item.icon size={18} />*/}
                  {item.label}
                </Box>
              }
              value={item.id}
            />
          ))}
        </Tabs>
      </Box>
      <div className="flex flex-col items-center gap-0 p-4" style={{ marginTop: '63px' }}>
        {spreadTypes[category as keyof typeof spreadTypes].map((item, key) => (
          <ReadingType onReadingClick={() => onReadingClick(key)} key={key} item={item} />
        ))}
      </div>
    </div>
  );
};

export default SelectReading;
